import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSuccess } from "../../Redux/AlertReducer";
import ContainerPop from "./ContainerPop";
import ButtonClose from "./ButtonClose";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import { setRefresh, setValueConfirm } from "../../Redux/DeleteReducer";
import { setOpen } from "../../Redux/ModalReducer";
import { CircularProgress } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

const DeletePops = () => {
  const [isLoading, setIsLoading] = useState(false);
  const value = useSelector((state) => state.Delete.ValueConfirm);
  const Refresh = useSelector((state) => state.Delete.Refresh);
  const Id = useSelector((state) => state.Delete.ID);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.stopPropagation();
    setIsLoading(true);
    try {
      const { result, response, message } = await Helper.Delete({
        url: `${api_Routes.ShopAds.Delete}/${value}/${Id}`,
      });
      if (response) {
        dispatch(setSuccess(true));
        dispatch(setRefresh(Refresh + 1));
      }
    } catch (error) {
      console.error("An error occurred during deletion:", error);
    } finally {
      setIsLoading(false);
      dispatch(setValueConfirm(""));
    }
  };

  const show = value === "ourService" || value === "type";

  return (
    <div
      className={`fixed inset-0 !z-50 ${
        show ? "visible" : "hidden"
      } bg-black bg-opacity-50 flex justify-center items-center`}
      onClick={() => {
        dispatch(setValueConfirm(""));
      }}
    >
      <ContainerPop>
        <div
          aria-label="pop delete"
          className="swals-show flex justify-center relative box-border flex-col z-30 w-[32em] max-w-full p-4 border-0 rounded-sm bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor m-auto"
        >
          <div aria-label="header" className="text-[1rem]">
            <div
              className="close absolute top-6 right-4 z-50 !cursor-pointer text-textColor dark:text-darkTextColor"
              onClick={() => {
                setValueConfirm("");
              }}
            >
              <IoMdCloseCircleOutline size={"1.3rem"} />{" "}
            </div>
            <div className="flex items-center justify-center w-[5em] h-[5em] mt-[1.25em] mx-auto mb-[1.875em] border-[.25em] border-[#facea8] text-[#facea8] rounded-full cursor-default">
              <div className="text-[3.75rem] leading-[5rem]">!</div>
            </div>
            <div className="relative flex justify-center items-center font-bold text-[#6c757d] text-3xl text-center">
              Are you sure?
            </div>
            <div className="block text-[#6c757d] font-semibold">
              You won't be able to revert this!
            </div>
            <div className="w-full mt-3 flex items-center justify-center">
              <button
                type="button"
                onClick={(e) => {
                  handleSubmit(e);
                }}
                disabled={isLoading}
                className="bg-primary m-1 py-2 px-8 font-medium text-[1.0625em] rounded-[0.25em] text-darkTextColor flex justify-center w-44"
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Yes, delete it!"
                )}
              </button>
              <ButtonClose
                onClick={() => {
                  dispatch(setValueConfirm(""));
                  dispatch(setOpen(false));
                }}
              />
            </div>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

export default DeletePops;
